module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "pl-2": "",
      "ml-2": ""
    }
  }, [(_vm.checklists.length > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-2": "",
      "pt-2": ""
    }
  }, [(_vm.casesId > 0 && this.vendorName) ? _c('h3', [_vm._v("Vendor \"" + _vm._s(_vm.vendorName) + "\" Products")]) : _c('h3', [_vm._v("Default checklist for the item")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-2": "",
      "pt-2": ""
    }
  }, _vm._l((_vm.checklists), function(checklist, i) {
    return _c('v-flex', {
      key: i
    }, [(checklist.editable) ? _c('v-flex', [_c('v-text-field', {
      attrs: {
        "append-icon": "save",
        "append-icon-cb": function () {
          _vm.saveCheckList(checklist)
        }
      },
      model: {
        value: (checklist.name),
        callback: function($$v) {
          _vm.$set(checklist, "name", $$v)
        },
        expression: "checklist.name"
      }
    })], 1) : _c('v-checkbox', {
      key: i,
      attrs: {
        "id": i.toString(),
        "label": checklist.service.name + ' - ' + '$' + checklist.service.price + ' - ' + checklist.service.category.name,
        "prepend-icon": _vm.showRemoveButton,
        "prepend-icon-cb": function () {
          _vm.deleteCheckList(checklist)
        }
      },
      on: {
        "change": function($event) {
          return _vm.toggleCheckListStatus(checklist)
        }
      },
      model: {
        value: (checklist.model),
        callback: function($$v) {
          _vm.$set(checklist, "model", $$v)
        },
        expression: "checklist.model"
      }
    })], 1)
  }), 1)], 1) : _c('v-flex', [(!_vm.loading.items) ? _c('span', [_vm._v("No items yet")]) : _vm._e(), _vm._v(" "), (_vm.loading.items) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.canAddToChecklist) ? _c('v-flex', [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.productsList,
      "label": "Manage products in checklist",
      "item-text": "name",
      "item-value": "id",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedProducts),
      callback: function($$v) {
        _vm.selectedProducts = $$v
      },
      expression: "selectedProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [(_vm.selectedProductsAsObjects.length > 0) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedProductsAsObjects,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteElementWrapper(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }], null, false, 674801953)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [(_vm.selectedProductsAsObjects.length > 0 && _vm.visible.attachServicesToCaseBtn) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.attachServicesToCaseBtn
    },
    on: {
      "click": _vm.attachServicesToCase
    }
  }, [_vm._v("Attach products to case")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05fe9e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemCheckList.vue
// module id = 948
// module chunks = 1